<script setup>
import {ref, computed, defineAsyncComponent, watch} from 'vue'
  import { useIdentificationUpgrade } from '@/composables/useIdentificationUpgrade.js';

  import { useStore } from 'vuex'
  const store = useStore()

  import { useCardsStore } from '@/store/stores/cards'
  import { settings } from "../appType/settings.js";
  const cardsStore = useCardsStore()

  // components block
  const ActivesCurrencySelect = defineAsyncComponent(() =>
      import(/* webpackChunkName: "components/base/selects/ActivesCurrencySelect" */ '@/components/base/selects/ActivesCurrencySelect.vue')
  )
  const CreateVirtualCard = defineAsyncComponent(() =>
      import(/* webpackChunkName: "components/zero_states/CreateVirtualCard" */ '@/components/zero_states/CreateVirtualCard.vue')
  )
  const KYCZeroState = defineAsyncComponent(() =>
      import(/* webpackChunkName: "components/zero_states/KYCZeroState" */ '@/components/zero_states/KYCZeroState.vue')
  )
  const Payment = defineAsyncComponent(() =>
      import(/* webpackChunkName: "components/Payment" */ '@/components/Payment.vue')
  )
  const TransactionsList = defineAsyncComponent(() =>
      import(/* webpackChunkName: "components/transactions/TransactionsList" */ '@/components/transactions/TransactionsList.vue')
  )
  const WalletList = defineAsyncComponent(() =>
      import(/* webpackChunkName: "components/WalletList" */ '@/components/WalletList.vue')
  )
  const ZeroBalanceState = defineAsyncComponent(() =>
      import(/* webpackChunkName: "components/zero_states/ZeroBalanceState" */ '@/components/zero_states/ZeroBalanceState.vue')
  )
  // end components block

  const topUpFunc = ref(() => {})

  const hasAuthInfo = computed(() => {
    return store.getters.hasAuthInfo
  })
  const authInfoLoading = computed(() => {
    return store.getters.authInfoLoading
  })
  const KYCPassed = computed(() => {
    return store.getters.kycPassed
  })
  const NullishBalance = computed(() => {
    return store.state.walletList?.every(({ balance }) => !Number(balance))
  })
  const cards = computed(() => {
    return cardsStore.getCards || []
  })

  const {
    upgradeLevel,
  } = useIdentificationUpgrade()

  const envName = settings.env.VUE_APP_ENV_NAME

  watch(hasAuthInfo,(v) => {
    if (!v && !authInfoLoading.value) {
      store.dispatch('refreshAuthInfo')
    }
  },{ immediate: true })
</script>

<template>
  <div class="home">
    <ActivesCurrencySelect v-if="envName === 'grok'" class="common-actives" />
    <WalletList />
    <Payment @update="event => topUpFunc = event" />
    <!--        <QrPay v-if="KYCPassed" />-->
    <KYCZeroState v-if="hasAuthInfo && !KYCPassed" @action="upgradeLevel" />
    <ZeroBalanceState v-else-if="hasAuthInfo && NullishBalance" :topUpFunc="topUpFunc" />
    <!--    <CreateVirtualCard v-else-if="!cards.length" />-->
    <TransactionsList :title="text('history.title')" />
  </div>
</template>

<style lang="scss" scoped>
.home {
  display: flex;
  flex-direction: column;
  gap: 20px;

  padding: 24px;

  .title {
    color: #FFF;
    font-family: "Rubik", sans-serif;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    letter-spacing: 0.36px;
    padding: 0 24px 25px;
  }
}

@media (max-width: 576px) {
  .home {
    padding: 16px;
  }
}
</style>